export const checkIfSmallScreen = () => {
  const mediaQuery = window.matchMedia("(max-width: 992px)");
  return mediaQuery.matches;
};
